import BENEFICIARY_TYPES from '@/modules/life/hiring/constants/BeneficiaryTypes'
type BeneficiaryParams = Required<Pick<LifeBeneficiary, 'beneficiaryRiskNumber'>> &
  Partial<Omit<LifeBeneficiary, 'beneficiaryRiskNumber'>>
export default class LifeBeneficiary {
  public riskNumber?: number = 1
  public beneficiaryType: string
  public beneficiaryRiskNumber: number
  public name: string
  public firstSurname: string
  public secondSurname: string
  public documentType: string
  public documentTypeText: string
  public documentNumber: string
  public distributionPercentage: number

  constructor(data: BeneficiaryParams) {
    this.beneficiaryType = data.beneficiaryType ?? BENEFICIARY_TYPES.CUSTOM
    this.beneficiaryRiskNumber = data.beneficiaryRiskNumber
    this.name = data.name ?? ''
    this.firstSurname = data.firstSurname ?? ''
    this.secondSurname = data.secondSurname ?? ''
    this.documentType = data.documentType ?? 'NIF'
    this.documentNumber = data.documentNumber ?? ''
    this.documentTypeText = data.documentTypeText ?? 'NIF'
    this.distributionPercentage = data.distributionPercentage ?? 0
  }

  getFullName() {
    return `${this.name} ${this.firstSurname} ${this.secondSurname}`
  }
}
